import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  fallbackLng: 'en',
  lng: 'en',
  resources: {
    en: {
      translations: require('./locales/en/translations.json')
    },
    gr: {
      translations: require('./locales/gr/translations.json')
    },
    pl: {
      translations: require('./locales/pl/translations.json')
    },
    pt: {
      translations: require('./locales/pt/translations.json')
    },
    se: {
      translations: require('./locales/se/translations.json')
    }
  },
  ns: ['translations'],
  defaultNS: 'translations'
});

i18n.languages = ['en', 'gr', 'pl', 'pt', 'se'];

export default i18n;